<script setup>
import {reactive, ref} from 'vue'
import { useStore } from 'vuex'

const store = useStore()

// const show = ref(false);
const name = ref('Ali')
const products = reactive([
  {id: 1, name: 'aaaaa', img: '27.png',price:250},
  {id: 2, name: 'bbbbb', img: '1704240147.jpg',price:150},
  {id: 3, name: 'ccccc', img: '2525.jpg',price:720},
  {id: 4, name: 'ddddd', img: '6653a6dbe14b1.webp',price:320},
  {id: 5, name: 'aaaaa', img: '27.png',price:110},
  {id: 6, name: 'bbbbb', img: '1704240147.jpg',price:350},
  {id: 7, name: 'ccccc', img: '2525.jpg',price:870},
  {id: 8, name: 'ddddd', img: '6653a6dbe14b1.webp',price:450},
  {id: 8, name: 'ddddd', img: '6653a6dbe14b1.webp',price:120},
])


function addToCart(product) {
  store.dispatch('cart/addToCart', product)
}

</script>

<template>
<!--  <b-card v-for="(product,index) in products" :key="index"
      title="Card Title"
      :img-src="'/img/'+product.img"
      img-alt="Image"
      img-top
      tag="article"
      style="max-width: 20rem;"
      class="mb-2"
  >
    <b-card-text>
      {{ product.name }}
    </b-card-text>

    <b-button href="#" variant="primary">{{ name }}</b-button>
  </b-card>-->

  <div class="container-fluid   ">
    {{ name }}
    <div class="row  ">
      <div class="col-lg-3 my-2" v-for="(product,index) in products" :key="index">
        <div class="card  ">
          <img class="card-img-top" :src="`/img/${product.img}`" :alt="product.name">
          <div class="card-body p-2">
            <span class="LinkShare position-absolute ">
                                     <div class="ItemShare">
                                         <span>
                                             <svg width="30" height="30" viewBox="0 0 22 22" fill="none"
                                                  xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M20.7789 10.5887C20.7789 16.2266 16.2085 20.797 10.5706 20.797C4.9327 20.797 0.362274 16.2266 0.362274 10.5887C0.362274 4.9508 4.9327 0.380371 10.5706 0.380371C16.2085 0.380371 20.7789 4.9508 20.7789 10.5887Z"
                                                        stroke="#57A4FF" stroke-width="0.5"></path>
                                                    <path
                                                        d="M15.6195 10.2281C15.6195 7.34301 12.3738 6.26113 10.5706 8.7856C8.76745 6.26115 5.88239 7.34302 5.88239 10.2281C5.88239 13.1131 9.12808 14.5557 10.9312 15.6376C12.7344 14.5557 15.6195 13.1131 15.6195 10.2281Z"
                                                        stroke="#57A4FF"></path>
                                            </svg>
                                         </span>
                                     </div>
                                     <div class="ItemShare"><span>
                                         <svg width="30" height="30" viewBox="0 0 21 22" fill="none"
                                              xmlns="http://www.w3.org/2000/svg">
                                              <circle cx="10.5" cy="11.321" r="10.25" stroke="#57A4FF"
                                                      stroke-width="0.5"></circle>
                                            <path
                                                d="M5.00006 7.44626H6.36898C6.63136 7.44557 6.88906 7.51607 7.11485 7.65032C7.34063 7.78457 7.52613 7.97758 7.65174 8.20896L11.3277 13.6336C11.4531 13.8646 11.6382 14.0573 11.8635 14.1916C12.0889 14.3258 12.3461 14.3965 12.608 14.3962C12.608 14.3962 13.6452 14.3962 15.0978 14.3962"
                                                stroke="#57A4FF" stroke-miterlimit="10" stroke-linecap="round"></path>
                                            <path
                                                d="M14.2532 13.1887L15.424 14.3639C15.4303 14.3701 15.4353 14.3774 15.4387 14.3856C15.4421 14.3937 15.4438 14.4024 15.4438 14.4112C15.4438 14.42 15.4421 14.4287 15.4387 14.4369C15.4353 14.445 15.4303 14.4524 15.424 14.4585L14.1695 15.6499"
                                                stroke="#57A4FF" stroke-miterlimit="10" stroke-linecap="round"></path>
                                            <path
                                                d="M5.00006 15.0215H6.36898C6.63078 15.0214 6.88774 14.9506 7.11288 14.8164C7.33802 14.6822 7.52304 14.4896 7.64852 14.2588L11.3245 8.83419C11.45 8.60248 11.6355 8.40918 11.8615 8.27477C12.0875 8.14036 12.3454 8.06984 12.608 8.07069H14.7371"
                                                stroke="#57A4FF" stroke-miterlimit="10" stroke-linecap="round"></path>
                                            <path
                                                d="M14.2535 9.27898L15.4243 8.10299C15.4305 8.09681 15.4355 8.08945 15.4389 8.08133C15.4423 8.0732 15.444 8.06448 15.444 8.05567C15.444 8.04686 15.4423 8.03814 15.4389 8.03002C15.4355 8.02189 15.4305 8.01453 15.4243 8.00836L14.1713 6.82104"
                                                stroke="#57A4FF" stroke-miterlimit="10" stroke-linecap="round"></path>

                                         </svg>
                                     </span></div>
                                     <div class="ItemShare">
                                         <span>
                                             <svg width="30" height="30" viewBox="0 0 22 22" fill="none"
                                                  xmlns="http://www.w3.org/2000/svg">
                                                 <path
                                                     d="M20.7789 10.5887C20.7789 16.2266 16.2085 20.797 10.5706 20.797C4.9327 20.797 0.362274 16.2266 0.362274 10.5887C0.362274 4.9508 4.9327 0.380371 10.5706 0.380371C16.2085 0.380371 20.7789 4.9508 20.7789 10.5887Z"
                                                     stroke="#57A4FF" stroke-width="0.5"></path>
                                                <path d="M11.6525 8.30716L8.04618 10.471" stroke="#57A4FF"></path>
                                                <path d="M8.40681 11.9135L11.2919 14.0773" stroke="#57A4FF"></path>
                                                <path
                                                    d="M8.26745 11.1922C8.26745 11.9119 7.684 12.4954 6.96429 12.4954C6.24457 12.4954 5.66113 11.9119 5.66113 11.1922C5.66113 10.4725 6.24457 9.88907 6.96429 9.88907C7.684 9.88907 8.26745 10.4725 8.26745 11.1922Z"
                                                    stroke="#57A4FF"></path>
                                                <circle cx="12.7344" cy="7.58591" r="1.30316" stroke="#57A4FF"></circle>
                                                <circle cx="12.7344" cy="14.7986" r="1.30316" stroke="#57A4FF"></circle>

                                            </svg>
                                         </span>
                                     </div>
                                     <div class="ItemShare"><span><svg width="30" height="30" viewBox="0 0 21 22"
                                                                       fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.6304" r="10.25" stroke="#57A4FF" stroke-width="0.5"></circle>
            <path
                d="M14.4848 14.0092H5.99997V11.8216C5.99997 11.8216 7.36361 11.6845 7.36361 8.54025C7.36361 5.39599 12.8182 5.2589 12.8182 8.54025C12.8182 11.8216 14.4848 11.8216 14.4848 11.8216V14.0092Z"
                stroke="#57A4FF"></path>
            <path d="M13.2727 6.13037C14.1818 7.03946 14.3333 7.94855 14.3333 9.31219" stroke="#57A4FF"
                  stroke-width="0.5" stroke-linecap="round"></path>
            <path d="M7.06058 6.13037C6.15149 7.03946 5.99997 7.94855 5.99997 9.31219" stroke="#57A4FF"
                  stroke-width="0.5" stroke-linecap="round"></path>
            <path
                d="M9.03027 14.7667C9.03027 15.1284 9.17394 15.4752 9.42967 15.731C9.6854 15.9867 10.0323 16.1304 10.3939 16.1304C10.7556 16.1304 11.1024 15.9867 11.3581 15.731C11.6139 15.4752 11.7575 15.1284 11.7575 14.7667L10.3939 14.7667L9.03027 14.7667Z"
                fill="#57A4FF"></path>
            </svg></span></div>
                                </span>
            <div class="divHeight">
              <div class="AddToCart">
                <a class="btn btn-link "  @click="addToCart(product)">
                  <span>
                                        <span>
                                        <svg width="21" height="19" viewBox="0 0 21 19" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M6.4375 17.3125C6.4375 16.415 7.16504 15.6875 8.0625 15.6875C8.95996 15.6875 9.6875 16.415 9.6875 17.3125C9.6875 18.21 8.95996 18.9375 8.0625 18.9375C7.16504 18.9375 6.4375 18.21 6.4375 17.3125Z"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M15.375 17.3125C15.375 16.415 16.1025 15.6875 17 15.6875C17.8975 15.6875 18.625 16.415 18.625 17.3125C18.625 18.21 17.8975 18.9375 17 18.9375C16.1025 18.9375 15.375 18.21 15.375 17.3125Z"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M0.75 1.0625C0.75 0.613769 1.11377 0.25 1.5625 0.25H4.8125C5.19976 0.25 5.5332 0.523313 5.6092 0.903041L6.2916 4.3125H19.4375C19.6796 4.3125 19.9092 4.4205 20.0635 4.60708C20.2179 4.79365 20.281 5.03934 20.2356 5.2772L18.9345 12.1002C18.823 12.6613 18.5177 13.1653 18.0721 13.524C17.6287 13.881 17.0744 14.0714 16.5055 14.0625H8.62202C8.05306 14.0714 7.49879 13.881 7.05539 13.524C6.60995 13.1654 6.30477 12.6617 6.19321 12.1009C6.19316 12.1006 6.19325 12.1011 6.19321 12.1009L4.83589 5.31935C4.83039 5.29692 4.82581 5.27412 4.82221 5.251L4.14651 1.875H1.5625C1.11377 1.875 0.75 1.51123 0.75 1.0625ZM6.61684 5.9375L7.78693 11.7836C7.82408 11.9706 7.92583 12.1386 8.07437 12.2582C8.22291 12.3778 8.40878 12.4413 8.59943 12.4376L8.615 12.4375H16.5125L16.5281 12.4376C16.7187 12.4413 16.9046 12.3778 17.0531 12.2582C17.201 12.1392 17.3025 11.9722 17.34 11.7862L18.4554 5.9375H6.61684Z"></path>
                                        </svg>
                                        </span>
                                        افزودن به سبد خرید
                                        </span>
                </a>
                <span>
                                        <svg width="10" height="30" viewBox="0 0 2 11" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 0.583984V10.5973" stroke="white" stroke-width="0.356038"></path>
                                        </svg>
                                        </span>





                <a href="#"><span>
                                        <span>
                                        <svg width="21" height="19" viewBox="0 0 12 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.81872 8.72303H4.96356C4.77341 8.72303 4.61572 8.56534 4.61572 8.37519C4.61572 8.18503 4.77341 8.02734 4.96356 8.02734H6.81872C7.00888 8.02734 7.16657 8.18503 7.16657 8.37519C7.16657 8.56534 7.00888 8.72303 6.81872 8.72303Z"></path>
                                        <path
                                            d="M1.25312 8.72333C1.06296 8.72333 0.905273 8.56564 0.905273 8.37549V3.73759C0.905273 1.69228 1.52675 1.0708 3.57206 1.0708C3.76222 1.0708 3.91991 1.22849 3.91991 1.41864C3.91991 1.6088 3.76222 1.76649 3.57206 1.76649C1.91633 1.76649 1.60096 2.07722 1.60096 3.73759V8.37549C1.60096 8.56564 1.44327 8.72333 1.25312 8.72333Z"></path>
                                        <path
                                            d="M10.5291 8.72333C10.3389 8.72333 10.1813 8.56564 10.1813 8.37549V3.73759C10.1813 2.07722 9.86588 1.76649 8.21015 1.76649C8.01999 1.76649 7.8623 1.6088 7.8623 1.41864C7.8623 1.22849 8.01999 1.0708 8.21015 1.0708C10.2555 1.0708 10.8769 1.69228 10.8769 3.73759V8.37549C10.8769 8.56564 10.7192 8.72333 10.5291 8.72333Z"></path>
                                        <path
                                            d="M3.66482 10.81H2.55173C1.42936 10.81 0.905273 10.2859 0.905273 9.16353V7.63766C0.905273 6.51529 1.42936 5.99121 2.55173 5.99121H3.66482C4.78719 5.99121 5.31128 6.51529 5.31128 7.63766V9.16353C5.31128 10.2859 4.78719 10.81 3.66482 10.81ZM2.55173 6.6869C1.8143 6.6869 1.60096 6.90024 1.60096 7.63766V9.16353C1.60096 9.90096 1.8143 10.1143 2.55173 10.1143H3.66482C4.40225 10.1143 4.61559 9.90096 4.61559 9.16353V7.63766C4.61559 6.90024 4.40225 6.6869 3.66482 6.6869H2.55173Z"></path>
                                        <path
                                            d="M9.23025 10.81H8.11716C6.99479 10.81 6.4707 10.2859 6.4707 9.16353V7.63766C6.4707 6.51529 6.99479 5.99121 8.11716 5.99121H9.23025C10.3526 5.99121 10.8767 6.51529 10.8767 7.63766V9.16353C10.8767 10.2859 10.3526 10.81 9.23025 10.81ZM8.11716 6.6869C7.37973 6.6869 7.16639 6.90024 7.16639 7.63766V9.16353C7.16639 9.90096 7.37973 10.1143 8.11716 10.1143H9.23025C9.96768 10.1143 10.181 9.90096 10.181 9.16353V7.63766C10.181 6.90024 9.96768 6.6869 9.23025 6.6869H8.11716Z"></path>
                                        </svg>

                                        </span>
                                        مشاهده سریع
                                        </span></a>
              </div>
            </div>
            <a href="#" class="card-text"><p class="m-1 font10">
              صنایع غذایی 1</p></a>
            <a href="#"><h6 class="card-title">{{ product.name }}</h6></a>
            <p class="card-text">
                            <span class="text-success font20">
                                1,420,000
                            </span>
              <span class="small text-muted"> تومان</span>
            </p>
            <s class="text-muted">
              2,000,000
            </s>
          </div>
        </div>
      </div>
    </div>

  </div>


</template>

<style scoped>
a{
  text-decoration: none;
}
</style>